import React from "react";
import "./QuestionCodeBlock.css";

const QuestionCodeBlock = ({ code, language, compact = false }) => {
  if (!code) return null;

  return (
    <div className={`question-code ${compact ? "compact" : ""}`}>
      <div className="question-code-head">
        <span>{language || "code"}</span>
      </div>
      <pre>
        <code>{code}</code>
      </pre>
    </div>
  );
};

export default QuestionCodeBlock;
